// @flow

// Effect Managers
import { call, fork } from 'redux-saga/effects'

import { watchOperations } from 'hfty-operator-accounts'

// Controller
import controller from 'hfty-ctrl-accounts'

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchOperations)
}
